import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "@/components/torq/Reveal";

const FACTS = [
  { k: "5.6 KM", v: "TOTAL RUNNING" },
  { k: "7", v: "FUNCTIONAL STATIONS" },
  { k: "1", v: "ARENA" },
];

const RACE_IMG =
  "https://images.unsplash.com/photo-1488656711237-487ce1cc53b7?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function TheRace() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="race"
      ref={ref}
      className="border-b border-[#2e2e2a] px-6 lg:px-12 py-24 lg:py-32"
      data-testid="race-section"
    >
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] text-[#ff5a1f] mb-10" data-testid="race-overline">
          01 / THE RACE
        </p>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <div>
          <Reveal delay={0.05}>
            <h2
              className="font-display font-extrabold uppercase leading-[0.9] text-[clamp(2.5rem,6vw,5.5rem)]"
              data-testid="race-heading"
            >
              RUNNING MEETS <span className="text-stroke">RAW STRENGTH</span> — REPEATED UNTIL NOTHING
              IS LEFT.
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p
              className="mt-8 max-w-xl text-[#a3a39f] leading-relaxed text-base lg:text-lg"
              data-testid="race-copy"
            >
              TORQ Circuit is the hybrid fitness race built for every body: eight 700-metre running
              legs and seven functional workout stations — 5.6 km of running before the finish line.
              One arena. One clock. No
              shortcuts, no excuses — just you, the course, and the version of yourself waiting at
              the finish line.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-12 grid grid-cols-3 border-t border-[#2e2e2a]" data-testid="race-facts">
              {FACTS.map((f) => (
                <div
                  key={f.v}
                  className="pt-6 pr-4 border-r border-[#2e2e2a] last:border-r-0 last:pr-0"
                  data-testid={`race-fact-${f.v.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <p className="font-display font-extrabold text-3xl lg:text-5xl">{f.k}</p>
                  <p className="mt-2 font-mono text-[10px] tracking-[0.2em] text-[#6e6e6a]">{f.v}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div
            className="relative overflow-hidden border border-[#2e2e2a] aspect-[4/5]"
            data-testid="race-image-frame"
          >
            <motion.img
              src={RACE_IMG}
              alt="Athlete climbing the ropes in a dark gym"
              style={{ y: imgY }}
              className="absolute inset-0 w-full h-[114%] object-cover grayscale contrast-125"
              data-testid="race-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#161614]/70 via-transparent to-transparent pointer-events-none" />
            <p
              className="absolute bottom-4 left-4 font-mono text-[10px] tracking-[0.25em] text-[#a3a39f]"
              data-testid="race-image-caption"
            >
              FIG. 01 — THE ENGINE ROOM
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
